import { LatLngExpression } from 'leaflet'
import { FC, ReactNode } from 'react'
import { LayerIdentifier } from '../Controls/LayersControl/LayerIdentifier'
import { Popup } from './'

export type Props = {
  position: LatLngExpression
  layer: string
  title: string
}
type ItemProps = {
  label: string
  value: ReactNode
  className?: string
}

const Item: FC<ItemProps> = ({ label, value, className }) => {
  return (
    <div className={`flex flex-col ${className}`}>
      <div className='text-gray-700 text-xs leading-5 uppercase'>{label}</div>
      <div className='text-sm leading-6'>{value}</div>
    </div>
  )
}

export const LayerPopup: FC<Props> & { Item: typeof Item } = ({
  position,
  layer,
  title,
  children,
}) => (
  <Popup position={position}>
    <div className='flex flex-col gap-2'>
      <div className='flex gap-2 items-center mr-4'>
        <LayerIdentifier $id={layer} />
        <div className='text-sm'>{title}</div>
      </div>
      {children}
    </div>
  </Popup>
)

LayerPopup.Item = Item
